import { IntlShape } from 'react-intl'
import { create, enforce, group, omitWhen, test } from 'vest'
import type {
  BuyTogetherBenefit,
  BuyTogetherTrigger,
} from '../../../../../typings'
import { messages } from '../messages'

export function suite(intl: IntlShape, trigger?: BuyTogetherTrigger) {
  return create((config: BuyTogetherBenefit) => {
    const { $t } = intl
    const { validation } = messages
    const { discount: discountSkusToGet, skus: skusToGet } = config

    group('benefit', () => {
      test(`skus`, $t(validation.selectAnOption), () => {
        enforce(skusToGet.length).gt(0)
      })

      test(`discount`, $t(validation.greaterThanOrEquals, { value: 0 }), () => {
        enforce(discountSkusToGet).gte(0)
      })

      test(`discount`, $t(validation.maxValue, { value: 100 }), () => {
        enforce(discountSkusToGet).lte(100)
      })

      omitWhen(!trigger, () => {
        test('skus', $t(validation.repeatedSkus), () => {
          const skusToGetIds = skusToGet.map(({ id }) => id)
          const skusToBuy = trigger!.skus

          enforce(
            skusToBuy.find((skuToGet) => skusToGetIds.includes(skuToGet.id))
          ).isFalsy()
        })
      })

      omitWhen(!trigger, () => {
        test(`discount`, $t(validation.discountNotZero), () => {
          const discountSkusToBuy = trigger!.discount
          enforce(discountSkusToBuy + discountSkusToGet).gt(0)
        })
      })
    })

    test(`discount`, $t(validation.maxValue, { value: 100 }), () => {
      enforce(discountSkusToGet).lte(100)
    })
  })
}
